export const MonthsNumber ={
  "Enero":"01",
  "Febrero":"02",
  "Marzo":"03",
  "Abril":"04",
  "Mayo":"05",
  "Junio":"06",
  "Julio":"07",
  "Agosto":"08",
  "Septiembre":"09",
  "Octubre":"10",
  "Noviembre":"11",
  "Diciembre":"12"
}

export const MonthsNumberDaterPicker ={
  "Enero":"00",
  "Febrero":"01",
  "Marzo":"02",
  "Abril":"03",
  "Mayo":"04",
  "Junio":"05",
  "Julio":"06",
  "Agosto":"07",
  "Septiembre":"08",
  "Octubre":"09",
  "Noviembre":"10",
  "Diciembre":"11"
}